import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom'
import List from './train/list.jsx'
import Train from './train'
import DWConfig from './config/dwConfig.jsx'
import RunningList from './config/running.jsx'
// import OrgList from './user/orgList.jsx';
// import UserList from './user/userList.jsx'
// import RoleList from './user/roleList.jsx'
// import PrivilegeList from './user/privilegeList.jsx'
// import MenuList from './user/menuList.jsx'
// import OrgUserList from './user/orgUserList.jsx'
import { Layout, Menu, Button } from 'antd';
import styled from 'styled-components'
import DataToggle from '../components/DataToggle';

// Import mock util (using relative path within src)
import { apiUtil as Util } from '../mock/mockServices';

// Mock localStorage if not available
if (typeof localStorage === 'undefined' || localStorage === null) {
  // 创建一个空的localStorage模拟对象，而不是填充默认用户信息
  Object.defineProperty(window, 'localStorage', {
    value: {
      _data: {},
      setItem: function(id, val) { return this._data[id] = String(val); },
      getItem: function(id) { return this._data.hasOwnProperty(id) ? this._data[id] : undefined; },
      removeItem: function(id) { return delete this._data[id]; },
      clear: function() { return this._data = {}; }
    },
    writable: true
  });
}

// 移除自动填充localStorage的代码
// const mockLocalStorage = getMockLocalStorage();
// if (!localStorage.authToken) localStorage.authToken = mockLocalStorage.authToken;
// if (!localStorage.authUserId) localStorage.authUserId = mockLocalStorage.authUserId;
// if (!localStorage.authUserName) localStorage.authUserName = mockLocalStorage.authUserName;
// if (!localStorage.authRoleList) localStorage.authRoleList = mockLocalStorage.authRoleList;
// if (!localStorage.authOrgId) localStorage.authOrgId = mockLocalStorage.authOrgId;

const { Header } = Layout;

class App extends Component {

  state = {
    current: '',
    isAdmin: false,
    userType: 'user' // 'user', 'admin', 'sysadmin'
  }

  logout = () => {
    Util.ajax.post('/common/loginOut').then(res => {
      window.location.href = '/login'
    })
  }

  componentDidMount() {
    let path = this.props.history.location.pathname
    if (path === '/train') {
      this.setState({
        current: 'train'
      });
    } else if (path === '/predict') {
      this.setState({
        current: 'predict'
      });
    } else {
      this.setState({
        current: ''
      });
    }
    
    if (path !== '/login' && path !== '/') {
      // 只有在用户已登录的情况下才获取用户信息
      if (localStorage.authToken && localStorage.authToken !== 'mock_auth_token' && localStorage.authUserName) {
        // Use mock API instead of real one
        Util.ajax.get('/common/user/' + localStorage.authUserId)
          .then(res => {
            // For mock purposes, determine user type based on orgId
            let userType = 'user';
            if (res.data.orgId === 'org_000' || res.data.userType === 'sysadmin') {
              userType = 'sysadmin';
            } else if (res.data.userType === 'admin') {
              userType = 'admin';
            }
            
            this.setState({ 
              isAdmin: userType === 'admin' || userType === 'sysadmin',
              userType: userType
            });
          })
          .catch(error => {
            // Even on error, we can set admin status for mock purposes
            this.setState({ 
              isAdmin: true,
              userType: 'sysadmin'
            });
          });
      }
    }
  }

  handleClick = e => {
    // Removed unused function
  };

  render() {
    return (
      <Root>
        <DataToggle />
        <Router>
          {
            this.props.history.location.pathname !== '/login' && <Header className="header">
              <div className="logo" >
                G.E.T Algo System
                </div>
              <Menu onClick={this.handleClick} selectedKeys={[this.state.current]} mode="horizontal" theme="dark">
                <Menu.Item key="home">
                  <a href="/">Home</a>
                  {/* <Link to="/">首页</Link> */}
                </Menu.Item>
                <Menu.Item key="train">
                  <Link to="/train">Train</Link>
                </Menu.Item>
                <Menu.Item key="predict">
                  <Link to="/predict">Predict</Link>
                </Menu.Item>
              </Menu>
              <div className="login-user_info">
                {/* 注释掉系统管理菜单，后续重新设计用户体验 */}
                {/* {
                  this.state.userType === 'sysadmin' && 
                  <Dropdown className="mr30" overlay={
                    <Menu onClick={this.handleClick}>
                      <Menu.Item key="org">
                        <Link to="/orgList">Organization Management</Link>
                      </Menu.Item>
                      <Menu.Item key="user">
                        <Link to="/userList">User Management</Link>
                      </Menu.Item>
                    </Menu>
                  }>
                    <span className="ant-dropdown-link">
                      System Management
                      </span>
                  </Dropdown>
                } */}
                {/* 注释掉组织管理菜单，后续重新设计用户体验 */}
                {/* {
                  (this.state.userType === 'admin' || this.state.userType === 'sysadmin') && 
                  <Dropdown className="mr30" overlay={
                    <Menu onClick={this.handleClick}>
                      <Menu.Item key="orgUser">
                        <Link to="/orgUserList">Organization User Management</Link>
                      </Menu.Item>
                    </Menu>
                  }>
                    <span className="ant-dropdown-link">
                      Organization Management
                      </span>
                  </Dropdown>
                } */}
                {/* <Divider type="vertical" /> */}
                <Button type="link" className="mr20" size="small" ghost onClick={() => window.open('DLM_GET_Algo_System.pdf')}>G.E.T Insights</Button>
                {/* <Divider type="vertical" /> */}
                {localStorage.authUserName ? (
                  <>
                    <i className="iconfont">&#xe667;</i> {localStorage.authUserName}
                    <i className="iconfont logout ml10" onClick={this.logout}>&#xe605;</i>
                  </>
                ) : (
                  <Link to="/login">Login</Link>
                )}
              </div>
            </Header>
          }
          <Route path="/predict" component={List} />
          <Route path="/dwConfig" component={DWConfig} />
          <Route path="/running" component={RunningList} />
          <Route path="/train" component={Train} />
          {/* 注释掉组织和用户管理相关路由，后续重新设计用户体验 */}
          {/* <Route path="/orgList" component={OrgList} />
          <Route path="/roleList" component={RoleList} />
          <Route path="/userList" component={UserList} />
          <Route path="/privilegelist" component={PrivilegeList} />
          <Route path="/menuList" component={MenuList} />
          <Route path="/orgUserList" component={OrgUserList} /> */}
        </Router>
        <div className="page-footer">G.E.T Algo System Copyright ©2025 G.E.T All Rights Reserved.</div>
      </Root>
    )
  }
}

export default App

const Root = styled.div`
.header {
  padding: 0;
  height: 45px;
  line-height: 45px;
  background-color: #053488;
  display: flex;
  .ant-menu-dark {
    background-color: #053488;
    .ant-menu-item {
      top: -1px;
    }
  }
    .logo {
        float: left;
        color: #fff;
        font-size: 16px;
        margin-right: 30px;
        width: 200px;
        text-align: left;
        padding-left: 30px;
    }
    .login-user_info{
        flex: 1;
        color: #fff;
        padding-right: 30px;
        text-align: right;
        line-height: 40px;
    }
    .ant-dropdown-link {
      cursor: pointer;
    }
    .logout {
      font-size: 24px;
      position:relative;
      cursor: pointer;
      top: 4px;
      color: #ccc;
    }
}
`;